import { saveUser } from 'communicator/store';

export default function tncAccepted() {
  saveUser({
    tnc: {
      status: 'accepted'
    }
  });
}
